import React, { useState } from "react";
import { Link } from "react-router-dom";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "../../aws-config";
import notification from "../../services/notification";

Amplify.configure(awsconfig);

const initialFormState = {
  code: "",
  password: "",
  confirmPassword: "",
};

const ResetPassword = ({ hideLoadingValue, showLoadingValue, history, username }) => {
  const [form, setForm] = useState(initialFormState);
  const handlerResetPassword = async () => {
    try {
      showLoadingValue();
      const user = await Auth.forgotPasswordSubmit(
        username,
        form.code,
        form.password
      );
      console.log(user);
      history.push("/auth/login");
      hideLoadingValue();
    } catch (error) {
      notification.error(error.message);
      hideLoadingValue();
    }
  };

  return (
    <>
      <div className="login-container">
        <i
          style={{
            fontSize: "32px",
            marginLeft: "18px",
            marginBottom: "15px",
            color: "#fff",
          }}
          className="material-icons dp48"
          onClick={() => {
            window.history.back();
            return false;
          }}
        >
          arrow_back
        </i>
        <h4 className="auth-header-page"> </h4>
        <h4 className="auth-header-page"> </h4>
        <div className="form-login-section">
          <div className="row" style={{ marginTop: "calc(32%)" }}>
            <h5 className="reset-password-header center-align">
              Reset Password
            </h5>
          </div>
          <div className="row" style={{ display: "flex" }}>
            <input
              type="text"
              className="auth-form-controller"
              name="code"
              placeholder="Verification Code"
              onChange={(event) => {
                setForm({ ...form, code: event.currentTarget.value });
              }}
            />
          </div>
          <div className="row" style={{ display: "flex" }}>
            <input
              type="password"
              className="auth-form-controller"
              name="password"
              placeholder="Password"
              onChange={(event) => {
                setForm({ ...form, password: event.currentTarget.value });
              }}
            />
          </div>
          <div className="row" style={{ display: "flex" }}>
            <input
              type="password"
              className="auth-form-controller"
              name="confirmPassword"
              placeholder="Confirm Password"
              onChange={(event) => {
                setForm({
                  ...form,
                  confirmPassword: event.currentTarget.value,
                });
              }}
            />
          </div>
          <div className="row">
            <button
              style={{ width: "100%" }}
              className="waves-effect waves-light submit-button"
              onClick={handlerResetPassword}
            >
              SUBMIT
            </button>
          </div>
          <div className="row">
            <div className="col s6 padding0">
              No account?{" "}
              <Link className="auth-from-link" to="/auth/register">
                {" "}
                Sign Up{" "}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
